import { createContext } from 'react';

export interface AuthContextProps {
  isLoggedIn: boolean;
  login: (password: string) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextProps | undefined>(
  undefined
);
